import React, { FunctionComponent, useEffect } from 'react';

const canUseDOM = () => {
    if (typeof window === 'undefined' || !window.document || !window.document.createElement) {
        return false;
    }
    return true;
};

export const ZendeskAPI = (...args: string[]) => {
    if (canUseDOM() && (window as any).zE) {
        (window as any).zE.apply(null, args);
    } else {
        console.warn('Zendesk is not initialized yet');
    }
};

const Zendesk: FunctionComponent<{ defer: boolean; onLoaded: () => void; userName: string; userEmail: string }> = ({
    defer,
    onLoaded,
    userEmail,
    userName
}) => {
    function onScriptLoaded() {
        if (typeof onLoaded === 'function') {
            () => onLoaded;
            (window as any).zE('webWidget', 'setLocale', 'en');

            (window as any).zE('webWidget', 'prefill', {
                name: {
                    value: userName,

                    readOnly: true // optional
                },
                email: {
                    value: userEmail,
                    readOnly: false // optional
                }
            });

            (window as any).zE('webWidget', 'helpCenter:setSuggestions', { labels: ['xyz'] });
        }
    }

    function insertScript() {
        const script = document.createElement('script');
        if (defer) {
            script.defer = true;
        } else {
            script.async = true;
        }
        script.id = 'ze-snippet';
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=555eb110-7cbe-447e-a6d8-fbacce105538`;
        script.addEventListener('load', onScriptLoaded);

        // script.append(`zE('webWidget', 'setLocale', "en");

        // zE('webWidget', 'prefill', {
        // 	name: {
        // 		value: "${userName}",

        // 		readOnly: true // optional
        // 	},
        // 	email: {
        // 		value: "${userEmail}",
        // 		readOnly: false // optional
        // 	}
        // });

        // zE('webWidget', 'helpCenter:setSuggestions', { labels: ['xyz'] });`);
        document.body.appendChild(script);
    }

    useEffect(() => {
        if (canUseDOM() && !(window as any).zE) {
            (window as any).zESettings = {
                webWidget: {
                    helpCenter: {
                        suppress: false
                    },
                    zIndex: 20,
                    position: {
                        horizontal: 'right',
                        vertical: 'top'
                    },
                    color: {
                        theme: '#eceff1',
                        launcherText: '#83B113'
                    },
                    offset: {
                        vertical: '-7%',
                        mobile: {
                            horizontal: '230px',
                            vertical: '100px'
                        }
                    }
                }
            };
            insertScript();
        }

        return () => {
            document.getElementById('ze-snippet')?.remove();
        };
    }, [window.location.pathname]);

    return <></>;
};

export default Zendesk;
